<template>
  <div v-show="isForgotPwd" class="contentBox">
    <div class="contentBox_leftBox">
      <img :src="zgoModImg" alt="">
    </div>
    <div class="contentBox_rightBox">
      <div class="topname">
        <span>重置密码</span>
      </div>
      <el-form ref="ruleForm" :model="ruleForm" status-icon :rules="rules" label-width="100px" class="demo-ruleForm">
        <el-form-item prop="phoneNumber">
          <el-input v-model="ruleForm.phoneNumber" auto-complete="off" placeholder="请输入手机号 ">
            <!--<i slot="prefix" class="el-icon-user ico"><svg-icon icon-class="user" /></i>-->
          </el-input>
        </el-form-item>
        <el-form-item prop="checkCode">
          <el-input v-model="ruleForm.checkCode" type="checkCode" auto-complete="off" placeholder="请确验证码 " class="checkbox">
            <!--<i slot="prefix" class="el-icon-user ico"><svg-icon icon-class="pwd" /></i>-->
          </el-input>
          <div v-show="isVcodeBtn" class="getVcodeBtn" @click="getVcode">
            获取验证码
          </div>
          <div v-show="!isVcodeBtn" class="getVcodeBtn num">
            重新发送 <span>({{ count }})</span>
          </div>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model.number="ruleForm.password" type="password" placeholder="请输入密码 ">
            <!--<i slot="prefix" class="el-icon-user ico"><svg-icon icon-class="pwd" /></i>-->
          </el-input>
        </el-form-item>
        <el-form-item prop="checkPass">
          <el-input v-model="ruleForm.checkPass" type="password" auto-complete="off" placeholder="请确认密码 ">
            <!--<i slot="prefix" class="el-icon-user ico"><svg-icon icon-class="pwd" /></i>-->
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="denglubtn" @click="submitForm('ruleForm')">
            重置密码
          </el-button>
          <!--<el-button @click="resetForm('ruleForm')">-->
          <!--重置-->
          <!--</el-button>-->
        </el-form-item>
      </el-form>
      <div class="register">
        记得密码？<span @click="gologin">立即登录</span>
      </div>
    </div>
  </div>
</template>
<script>
import { getVcode, resetPassword } from '@/api/api.js'
export default {
  inject: ['reload'],
  data() {
    var checkpass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    var checkvcode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'))
      }
      setTimeout(() => {
        if (!(/^1[34578]\d{9}$/.test(value))) {
          callback(new Error('格式错误，请输入正确的手机号'))
        } else {
          callback()
        }
      }, 500)
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value + '' !== this.ruleForm.password + '') {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      zgoModImg: require('@/static/zgw-mod.jpg'),
      loginIMG: require('@/static/loginIMG_new.png'),
      show: false,
      isForgotPwd: false,
      isVcodeBtn: true,
      count: 60,
      ruleForm: {
        phoneNumber: '',
        checkPass: '',
        password: '',
        checkCode: ''
      },
      rules: {
        phoneNumber: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        password: [
          { validator: checkpass, trigger: 'blur' }
        ],
        checkCode: [
          { validator: checkvcode, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
  },
  methods: {
    submitForm(formName) { // //登录验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj1 = {}
          obj1.phone = this.ruleForm.phoneNumber
          obj1.password = this.ruleForm.password
          obj1.validCode = this.ruleForm.checkCode
          resetPassword(obj1).then(res => {
            if (res.data.success) {
              this.$message({
                message: '重置密码成功',
                type: 'success',
                duration: 2000
              })
            } else {
              this.$message({
                message: '重置密码失败',
                type: 'error',
                duration: 2000
              })
            }
          })
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    goregisted() { // 去注册
      this.$router.replace({ path: '/register' })
    },
    changeContent() { // /忘记密码
      this.isForgotPwd = true
    },
    gologin() { // //去登录
      this.$router.replace({ path: '/login' })
      this.reload()
    },
    getVcode() { // /点击发送验证码
      this.ruleForm.checkCode = ''
      if (!(/^1[34578]\d{9}$/.test(this.ruleForm.phoneNumber))) {
        this.$message({
          message: '请正确输入手机号',
          type: 'error',
          duration: 2000
        })
      } else {
        var obj = {}
        obj.phone = this.ruleForm.phoneNumber
        obj.codeType = '2'
        this.isVcodeBtn = false
        var timers = setInterval(() => {
          this.count--
          if (this.count <= 0) {
            this.isVcodeBtn = true
            clearInterval(timers)
          }
        }, 1000)
        getVcode(obj).then(res => {
          if (res.code == 200) {
            this.$message({
              message: '短信验证已发送',
              type: 'success',
              duration: 2000
            })
          }
        })
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .bgI{
        width: 100%;
        overflow: hidden;
        position: relative;
        img{
            width: 100%;
            height: 100%;
        }
      .contentBox{
        margin: 100px auto 80px;
        height: 440px;
        width: 420px;
        background-color: #fff;
        border-left: 1px solid #f0f0f0;
        border-right: 1px solid #f0f0f0;
        border-bottom: 1px solid #f0f0f0;
        -moz-box-shadow:1px 1px 3px #f3f3f3;
        -webkit-box-shadow:1px 1px 3px #f3f3f3;
        box-shadow:1px 1px 3px #f3f3f3;
        .topname{
          margin: 20px auto;
          margin-top: 0;
          /*margin-top: 20px;*/
          overflow: hidden;
          text-align: center;
          .registerbtn{
            border: none;
            cursor: pointer;
          }
          span{
            display: inline-block;
            width: 75px;
            height: 50px;
            font-size: 17px;
            line-height: 50px;
            margin-left: 10px;
            border-bottom: 2px solid #ed4040;
          }
        }

      }
    }
    .ico{
        height: 40px;
        width: 30px;
        color: #ed4040;
    }
    .denglubtn{
        width: 320px;
        background-color: #E3003A;
        border-color: #E3003A;
    }
    .forgotpwd{
        color: #808080;
        text-align: center;
        font-size: 12px;
        cursor: pointer;
        &:hover{
            color: #ed4040;
        }
    }
    .register{
        text-align: center;
        font-size: 12px;
        color: #808080;
        margin-top: 15px;
        span{
            font-size: 12px;
            color: #ed4040;
            cursor: pointer;
        }
    }
    .wxlogin{
        text-align: center;
        margin-top: 30px;
        svg{
            width: 40px;
            height: 40px;
            color: #00bb00;
        }
        p{
            font-size: 12px;
            color:#808080;
        }
    }
    .checkbox{
        width: 210px;
    }
    .getVcodeBtn{
        width: 100px;
        display: inline-block;
        background-color: #ed4040;
        margin-left: 10px;
        border-radius: 5px;
        text-align: center;
        color: #ffffff;
        font-size: 12px;
        cursor: pointer;
    }
    .contentBox_rightBox{
      display: inline-block;
      width: 460px;
      border-left: 1px solid #EEEEEE;
      height: 380px;
      vertical-align: top;
    }
    .contentBox_leftBox{
      display: inline-block;
      vertical-align: top;
      width: 339px;
      margin: 50px auto;
      text-align: center;
      img{
        width: 200px;
        height: 270px;
      }
    }
</style>

